import React from 'react';

import WixStyleReactProvider from '../WixStyleReactProvider';
import { WixDesignSystemProviderProps } from './WixDesignSystemProvider.types';

/** WixDesignSystemProvider */
const WixDesignSystemProvider: React.FC<WixDesignSystemProviderProps> = ({
  children,
  ...rest
  // @ts-ignore
}) => <WixStyleReactProvider {...rest}>{children}</WixStyleReactProvider>;

WixDesignSystemProvider.displayName = 'WixDesignSystemProvider';

export default WixDesignSystemProvider;
